export const SHOW_NOTIFICATIONS = "SHOW_NOTIFICATIONS";
export const HIDE_NOTIFICATIONS = "HIDE_NOTIFICATIONS";
